import React, { FC } from 'react';
import { MicroFrontend, SpecificMicroFrontendProps } from '../../core';
import { constants } from './constants';

export type FactoryGptMicroFrontendProps = SpecificMicroFrontendProps & {
  isWidget?: boolean;
};

export const FactoryGptMicroFrontend: FC<FactoryGptMicroFrontendProps> = ({
  entryPointUrl,
  ...props
}) => {
  return (
    <MicroFrontend
      entryPointUrl={entryPointUrl}
      name={constants.MFE_FACTORY_GPT_NAME}
      exposedPath={constants.MFE_EXPOSED_PATH}
      {...props}
    />
  );
};

export const FactoryGptWidget: FC<FactoryGptMicroFrontendProps> = ({
  entryPointUrl,
  ...props
}) => {
  return (
    <MicroFrontend
      entryPointUrl={entryPointUrl}
      name={constants.MFE_FACTORY_GPT_NAME}
      exposedPath={constants.WIDGET_EXPOSED_PATH}
      {...props}
    />
  );
};
